<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="旧机返厂" size="30%" :before-close="handleClose" :visible.sync="drawer"
               append-to-body="ture" direction="rtl" :modal-append-to-body="true" custom-class="demo-drawer" ref="drawer">
      <i class="el-icon-info" />
      单据号：<span v-if="exchangeOrderNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
        exchangeOrderNo }}</span>
      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <el-form :label-position="right" label-width="80px" ref="editForm" :model="formData">
              <el-form-item label="物流公司" >
                <el-select v-model="formData.returnLogisticsCompany" filterable style="width:10vw!important;" :disabled="able"
                           clearable>
                  <el-option v-for="item in logisticsCompaniesList" :key="item.value" :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="物流单号" >
                <el-input type="text" autocomplete="off" v-model="formData.returnLogisticsNo" :disabled="able"
                          style="width:10vw!important;" clearable />
              </el-form-item>

              <el-form-item label="安装时间" >
                <el-date-picker v-model="formData.installTime" type="datetime" placeholder="选择日期时间"
                                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="optionsDisable"
                                style="width:10vw!important;">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="安装工单" >
                <el-input type="text" autocomplete="off" v-model="formData.installOrderNo" :disabled="able"
                          style="width:10vw!important;" clearable >
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="searchOrder"></i>
                </el-input>
              </el-form-item>
              <el-form-item label="安装型号" >
                <el-input type="text" autocomplete="off" v-model="formData.installVersion" :disabled="able"
                          style="width:10vw!important;" clearable />
              </el-form-item>
              <el-form-item label="安装条码" >
                <el-input type="text" autocomplete="off" v-model="formData.installBarcode" :disabled="able"
                          style="width:10vw!important;" clearable />
              </el-form-item>

              <el-form-item label="备 注" >
                <el-input type="textarea" autocomplete="off" v-model="formData.messageContent" :disabled="able"
                          style="width:10vw!important;" clearable />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <div class="demo-drawer__content">
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary"  @click="siteAppeal">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

    <orderPop v-if="showOrderPop" @commit="orderCommit" :visiable.sync="showOrderPop" :showBigSiteName="true" :siteId="obj.siteId"
              :settleType="orderType" multi="true" />
  </div>
</template>
<script>
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";
import orderPop from "@/views/dialogCommon/radioOrderDialog.vue";

export default {
  components: {orderPop},
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'exchangeOrderNo', 'exchangeOrderId', 'obj'],
  created() {
    this.formData.id = this.exchangeOrderId
    //获取对应的安装单
    if(this.obj.installOrderId) {
      this.getDefultOrderMsg()
    }
  },
  data() {
    return {
      orderType: 1,

      uploadFileUrl: api.uploadFileUrl,
      logisticsCompaniesList: [],

      siteAppealButton: false,

      formData: {
        id: null,
        processId: null,
        taskId: null,
        returnLogisticsCompany: null,
        returnLogisticsCompanyName: null,
        returnLogisticsNo: "",
        messageContent: null,

        installTime: null,
        installOrderNo: null,
        installVersion: null,
        installBarcode: null,
      },

      rules: {

        installTime: [
          { required: true, prop: '安装时间', message: '安装时间不能为空', trigger: 'blur' }
        ],
        installOrderNo: [
          { required: true, prop: '安装工单', message: '安装工单不能为空', trigger: 'blur' }
        ],
        installVersion: [
          { required: true, prop: '安装型号', message: '安装型号不能为空', trigger: 'blur' }
        ],
        installBarcode: [
          { required: true, prop: '安装条码', message: '安装条码不能为空', trigger: 'blur' }
        ],

      },
      showOrderPop: false,

      drawer: true,
    }
  },
  methods: {
    getDefultOrderMsg(){
      this.$http({
        url: "/basic/wkExchangeOrder/getInstallOrderMsg",
        method: 'post',
        data: {id:this.obj.installOrderId}
      }).then(res => {
        let data = res.data.data
        this.formData.installOrderNo = data.orderNo
        this.formData.installVersion = data.itemModel
        this.formData.installTime = data.completeTime
        this.formData.installBarcode = data.resultBarcode
      }).catch(() => {
      })
    },
    searchOrder() {
      console.log("this.obj.siteId", this.obj.siteId)
      // if (!this.formData.siteId) {
      //   errorMsg += '网点 '
      // }

      this.showOrderPop = true;
    },

    // 工单弹框选中
    orderCommit(data) {
      console.log('选中的工单', data)

      this.formData.installOrderNo = data.orderNo
      this.formData.installVersion = data.itemModel
      this.formData.installTime = data.completeTime
      this.formData.installBarcode = data.resultBarcode
      console.log("data---------",data)

    },

    // 旧件退回
    siteAppeal() {

      let returnLogisticsCompany = this.formData.returnLogisticsCompany
      if (returnLogisticsCompany) {
        this.logisticsCompaniesList.forEach(item => {
          if (returnLogisticsCompany === item.value) {
            this.formData.returnLogisticsCompanyName = item.label
          }
        })
      }

      this.$validate(this.formData, this.rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()
          this.$http({
            url: "/basic/wkExchangeOrder/backMachine",
            method: 'post',
            data: this.formData
          }).then(res => {
            this.$mask.close()
            this.$message.success('确认成功')
            this.$emit('closeDialog',true)
          }).catch(() => {
            this.$mask.close()
            this.$emit('closeDialog',true)
          })
        })
      })

    },

    optionsDisable: {
      disabledDate(time) {
        return time.getTime() > Date.now();
      },
    },

    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      // 物流公司
      loadDictData(dictType.logisticsCompanies).then(res => {
        this.logisticsCompaniesList = []
        res.data.data.forEach(item => {
          this.logisticsCompaniesList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeDialog',false)
    }
  },
  mounted() {
    this.loadDictData()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
